module.exports = __webpack_public_path__ + "static/media/guidelines.9d64d46c.png";